import axios from "axios";
import { Response } from "../../../shared/models/Response";
import { InfoGroupModel } from "../models/InfoGroup";
import { InfoGroupQuerySend } from "../models/InfoGroupQuerySend";
import { InfoGroupDataResponse } from "../models/InfoGroupDataResponse";
import { InfoGroupDetail } from "../models/InfoGroupDetail";
import { NotificationParams } from "@/modules/Notification/models/NotificationParams";

export class InfoGroupService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_USERS_API}/info-group`;
  }

  async addInfoGroup(
    infoGroup: InfoGroupModel
  ): Promise<Response<string | void>> {
    return (await axios.post(this.baseUrl, infoGroup)).data;
  }

  async checkIfExistByName(name: string): Promise<Response<void>> {
    const serviceURL = `${this.baseUrl}/exist-by-name`;

    const params = {
      params: {
        nameInfoGroup: name
      }
    };

    const response = await axios.get(serviceURL, params);
    return response.data;
  }

  async getInfoGroupByFilters(
    query: InfoGroupQuerySend
  ): Promise<Response<InfoGroupDataResponse>> {
    const serviceURL = `${this.baseUrl}/find-by-filters`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async updateStateInfoGroupById(
    id: string,
    state: string
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/state/${id}/${state}`;
    const response = await axios.put(serviceUrl);
    return response.data;
  }

  async getInfoGroupById(id: string): Promise<Response<InfoGroupModel>> {
    const serviceURL = `${this.baseUrl}/${id}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async getInfoGroupSchemaById(id: string): Promise<Response<InfoGroupDetail>> {
    const serviceURL = `${this.baseUrl}/schema/${id}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async updateInfoGroup(
    id: string,
    infoGroup: InfoGroupModel
  ): Promise<Response<string | void>> {
    const serviceURL = `${this.baseUrl}/${id}`;
    const response = await axios.put(serviceURL, infoGroup);
    return response.data;
  }

  async getInfoGroupFieldByName(
    name: string
  ): Promise<Response<NotificationParams[]>> {
    const serviceURL = `${this.baseUrl}/fields-by-name`;
    const response = await axios.get(serviceURL, { params: { name: name } });
    return response.data;
  }

  async deleteInfoGroup(id: string): Promise<Response<string | void>> {
    return (await axios.delete(`${this.baseUrl}/${id}`)).data;
  }
}
